import { useNavigate } from "react-router";
import { inject, observer } from "mobx-react";
import { withAuthentication } from "../components/AuthenticateUser";
import StreamingTest from "../components/StreamingTest";

const StreamingTestPage = ({ userStore }) => {
  const { isAdmin } = userStore;
  const navigate = useNavigate();

  if (!isAdmin) {
    navigate("/", { replace: true });
    return null;
  }

  document.title = "Streaming Markdown Test — Plex Search";

  return (
    <div className="streaming-test-page">
      <StreamingTest />
    </div>
  );
};

export default withAuthentication(inject("userStore")(observer(StreamingTestPage)));
